import React from "react";

export const BOTANICAL_SRC =
    "https://customer-assets.emergentagent.com/job_practice-portal-15/artifacts/utlab3mt_ChatGPT%20Image%20May%2027%2C%202026%20at%2003_19_10%20PM.png";

/**
 * Soft celestial-botanical overlay.
 * Inverts the source so light/sage lines on white become near-white lines on a dark base,
 * then uses mix-blend: screen so only the light lines lift the colored section background.
 *
 * variant:
 *   "full"        — full bleed background wash
 *   "right"       — right half, bleeds off right + bottom, fades L→R (gradient mask)
 *   "left"        — left half, bleeds off left + bottom, fades R→L
 */
export default function BotanicalOverlay({ variant = "full", opacity = 0.06 }) {
    const common = {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        opacity,
        mixBlendMode: "screen",
        filter: "invert(1) brightness(1.05)",
        backgroundImage: `url(${BOTANICAL_SRC})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
    };

    let style = { ...common };

    if (variant === "right") {
        style = {
            ...style,
            left: "auto",
            right: "-8%",
            bottom: "-12%",
            top: 0,
            width: "62%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right bottom",
            backgroundSize: "cover",
            WebkitMaskImage:
                "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,1) 100%)",
            maskImage:
                "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,1) 100%)",
        };
    } else if (variant === "left") {
        style = {
            ...style,
            right: "auto",
            left: "-8%",
            bottom: "-12%",
            top: 0,
            width: "62%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left bottom",
            backgroundSize: "cover",
            WebkitMaskImage:
                "linear-gradient(270deg, transparent 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,1) 100%)",
            maskImage:
                "linear-gradient(270deg, transparent 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,1) 100%)",
        };
    }

    return <div aria-hidden data-testid="botanical-overlay" style={style} />;
}
